import { HTTP } from 'providers'

export class ChargeDataService extends HTTP {
  private endpoint = '/csv/sampco'
  private config: Record<string, any> = {
    showLoading: true
  }

  public fetchLogs(params?: Record<string, any>) {
    console.log('params', params)
    return this.get({
      endpoint: `${this.endpoint}/logs`,
      params
    })
  }

  public uploadFile(payload: { file: File; method?: string }) {
    const { file, method = 'upload' } = payload

    const multipartForm = new FormData()
    multipartForm.append('file', file)
    multipartForm.append('method', method)

    return this.post({
      endpoint: `${this.endpoint}/upload`,
      payload: multipartForm,
      config: {
        ...this.config,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        transformRequest: [data => data]
      }
    })
  }
}
